import {
  type CardUpdateInput,
  type CardUpdateSuccess,
  type DecoratedCard,
  Logger,
  toResponseError,
} from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useCardCache } from './cache'

const logger = new Logger('useUpdateCard')

export function useUpdateCard(): UpdateHookResponse<CardUpdateInput['card'], DecoratedCard> {
  const cache = useCardCache()
  const mutation = useTantalimMutation<CardUpdateInput, CardUpdateSuccess>({ url: '/card/update' })

  async function update(card: CardUpdateInput['card']): Promise<DecoratedCard> {
    try {
      logger.verbose('starting update', card.entityId)
      const response = await mutation.mutateAsync({ card })
      cache.clearItem(card.entityId)
      return response.card
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
